"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentEmployerRelation = void 0;
var _lodash = require("lodash");
var getCurrentEmployerRelation = function getCurrentEmployerRelation(patientEmployerRelations) {
  var pendingOrActiveRelations = (0, _lodash.filter)(patientEmployerRelations, function (relation) {
    return relation.status === 1 || relation.status === 2;
  });
  var mostRecentPendingOrActiveRelations = (0, _lodash.orderBy)(pendingOrActiveRelations, ['status', 'updatedAt'], ['asc', 'desc']);
  return (0, _lodash.isEmpty)(pendingOrActiveRelations) ? undefined : mostRecentPendingOrActiveRelations[0];
};
exports.getCurrentEmployerRelation = getCurrentEmployerRelation;